import React, { useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import {
  Switch,
  Route,
  Link,
  useParams,
  useRouteMatch,
  useHistory,
} from "react-router-dom";
import { parseShowDate, parseShowTime } from "../libraries/time.jsx";
import showPlaceholder from "../img/show-placeholder.jpg";
import { XIcon } from "@heroicons/react/solid";
import CalcCrow from "../libraries/calcCrow.js";

const Venue = (props) => {
  const history = useHistory();
  let { venueId } = useParams();
  useEffect(() => {
    props.setSelectedVenue(venueId);
  });

  const FIND_VENUE = gql`
  {
  findVenueByID (id: ${venueId}) {
    _id
    name
    description
    address
    placeId
    thumbnail
    shows {
      data {
        _id
        name
        start_time
        end_time
        thumbnail
      }
    }
  }
}
`;
  const { data, loading, error } = useQuery(FIND_VENUE);
  if (loading) {
    return "Loading...";
  }
  if (error) return `Error! ${error}`;
  let venueData = data.findVenueByID;

  return (
    <div className="glass rounded-t-md relative">
      <XIcon
        className="absolute w-8 h-8 top-2 right-2 z-10"
        onClick={() => history.push("/")}
      />
      <div className="px-2 mb-2">
        <p className="text-2xl pr-16">{venueData.name}</p>
        <img className="w-full" src={venueData.thumbnail} alt="" />
        <p className=" text-gray-500 pt-2 text-lg">upcoming events:</p>
        <div className="">
          <ul className="space-y-3 mt-6">
            {venueData.shows.data.map((show) => {
              return (
                <li
                  className="bg-white shadow overflow-hidden rounded-md"
                  key={show._id}
                >
                  <Link className="flex" to={`/events/${show._id}`}>
                    <div
                      className="w-1/4 rounded-l-md bg-cover bg-center"
                      style={{ backgroundImage: `url(${show.thumbnail})` }}
                    ></div>
                    <div className="px-2 py-1 pb-4">
                      <p className="line-clamp-1">{show.name}</p>
                      {parseShowDate(show.start_time)}
                      <div className="flex">
                        {parseShowTime(show.start_time)}{" "}
                        <span className="mx-2">-</span>
                        {parseShowTime(show.end_time)}
                      </div>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="px-2 mb-4">
        <div className="mb-2 text-xl"></div>
        <div className="flex mb-4">
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${venueData.lat}%2C${venueData.long}&query_place_id=${venueData.placeId}`}
            target="_blank"
            rel="noreferrer"
          >
            <button className="py-2 px-4 bg-blue-500 text-white font-semibold rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75">
              directions
            </button>
          </a>
        </div>
        <p className="line-clamp-4">{venueData.description}</p>
        <p className="text-xs text-gray-500">read more</p>
      </div>
    </div>
  );
};

export const ListVenues = (props) => {
  const history = useHistory();
  let { path, url } = useRouteMatch();
  const GET_VENUES = gql`
    {
      getVenues {
        data {
          _id
          name
          address
          thumbnail
          placeId
          lat
          long
          active
          shows {
            data {
              _id
              start_time
              end_time
            }
          }
        }
      }
    }
  `;
  const { data, loading, error } = useQuery(GET_VENUES);

  if (loading) {
    return "Loading...";
  }
  if (error) return `Error! ${error}`;

  const activeVenues = data.getVenues.data.filter(
    (venue) => venue.active === true
  );

  let calculatedVenues = [];

  activeVenues.forEach((venue) => {
    const distance = CalcCrow(
      venue.lat,
      venue.long,
      props.userPosition[0],
      props.userPosition[1]
    );

    calculatedVenues.push({
      ...venue,
      userDistance: distance,
    });
  });
  const sortedVenues = calculatedVenues.sort((a, b) =>
    a.userDistance > b.userDistance ? 1 : -1
  );

  return (
    <div className="pt-32 h-screen overflow-y-auto lg:w-1/3 lg:pt-20">
      <Switch>
        <Route exact path={path}>
          <div className="glass rounded-t-md pt-2 relative">
            <XIcon
              className="absolute w-8 h-8 top-2 right-2 z-10"
              onClick={() => history.goBack()}
            />
            <p className="px-2 pb-4 text-xl">Venues</p>
            <ul className="space-y-3 px-2">
              {sortedVenues.map((venue) => {
                return (
                  <li
                    className="bg-white shadow overflow-hidden rounded-md"
                    key={venue._id}
                  >
                    <Link className="flex" to={`${url}/${venue._id}`}>
                      <div
                        className="w-1/4 rounded-l-md bg-cover bg-center"
                        style={{ backgroundImage: `url(${venue.thumbnail})` }}
                      ></div>
                      <div className="px-6 py-1 pb-4">
                        <p className="line-clamp-1">{venue.name}</p>
                        <p className="text-xs text-gray-500 line-clamp-1">
                          {venue.address}
                        </p>
                        <p className="">
                          {venue.shows.data.length}
                          <span className="text-xs pl-1">upcoming events</span>
                        </p>
                      </div>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </Route>
        <Route path={`${path}/:venueId`}>
          <Venue
            selectedVenue={props.selectedVenue}
            setSelectedVenue={props.setSelectedVenue}
          />
        </Route>
      </Switch>
    </div>
  );
};
